module.exports = __webpack_public_path__ + "../resources/images/illustration_inbox-1097f6498db25829c616b193f40d15c9.svg";